import React from 'react';
import './style.scss';

// These tiers and benefits follow the supplied Chinese comparison chart.
const tiers = [
  { id: 'silver', name: '银卡', english: 'SILVER', points: ['0 - 24999 ', '积分'] },
  { id: 'gold', name: '金卡', english: 'GOLD', points: ['25000 - ', '49999积分'] },
  { id: 'titanium', name: '钛金卡', english: 'TITANIUM', points: ['50000及', '以上积分'] }
];

const benefits = [
  { name: '入住获得积分（可累计积分的客房）', values: [true, true, true] },
  { name: '会员专属优惠价', values: [true, true, true] },
  { name: '室内免费网络或高速网络接入', values: [true, true, true] },
  { name: '提前入住，延迟退房*', values: [true, true, true] },
  { name: '升级版客房升级服务**', values: [true, true, true] },
  { name: 'I Prefer Loves 会员专享福利', values: [true, true, true], branded: true },
  { name: '参与套房特别优惠', values: [true, true, true] },
  { name: '碧旅阁林丰富的福利活动奖励**', values: [true, true, true] },
  { name: '璞富腾电子杂志', values: [true, true, true] },
  { name: '欢迎礼遇**', values: [false, true, true] },
  { name: '积分奖励***', values: [false, '20%', '50%'] },
  { name: '特惠及独特体验', values: [false, false, true] },
  { name: '餐饮优惠**', values: [false, false, true] },
  { name: '纪念日电子礼遇', values: [false, false, true] }
];

function BenefitValue({ value }) {
  if (typeof value === 'string') {
    return <span className="preferred-points-bonus">{value}</span>;
  }

  return (
    <>
      {value && <span className="preferred-benefit-dot" aria-hidden="true" />}
      <span className="preferred-sr-only">{value ? '享有' : '未列示'}</span>
    </>
  );
}

export default function PreferredBenefits() {
  return (
    <main>
     
      <h1 className="hotel-member-title">
        <img className="hotel-member-logo preferred-logo" src="https://staticfile.badazhou.com/20260922/46495b14cac5b233307fcff9f3211752.png" alt="" />
        <span>I Prefer-会员礼遇</span>
      </h1>

      <section className="preferred-benefits" aria-label="I Prefer 会员权益">
        <p className="preferred-introduction">
          所有的<em>I Prefer</em>会员可在参与<em>I Prefer</em>会员计划的璞富腾酒店及度假村成员酒店，通过有效住宿获得积分。会籍免费注册并可享如下一系列会员专属礼遇。
        </p>
        <div className="preferred-table-scroll" role="region" aria-label="会员权益对照表" tabIndex={0}>
          <table aria-describedby="preferred-footnotes">
            <caption className="preferred-sr-only">I Prefer 会员等级和福利对照表</caption>
            <colgroup>
              <col className="preferred-benefit-column" />
              {tiers.map((tier) => <col key={tier.id} />)}
            </colgroup>
            <thead>
              <tr>
                <th scope="col" className="preferred-table-label">
                  <h2>会员积分及权益</h2>
                  <div className="preferred-table-subtitle"><em>I Prefer</em> <span>会员等级和福利</span></div>
                </th>
                {tiers.map((tier) => (
                  <th scope="col" key={tier.id} className="preferred-tier">
                    <span className="preferred-tier-name">{tier.name}</span>
                    <span className="preferred-tier-english" lang="en">{tier.english}</span>
                    <span className="preferred-tier-points">
                      <span>（{tier.points[0]}</span>
                      <span>{tier.points[1]}）</span>
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {benefits.map((benefit) => (
                <tr key={benefit.name}>
                  <th scope="row">
                    {benefit.branded ? <><em>I Prefer</em> Loves 会员专享福利</> : benefit.name}
                  </th>
                  {benefit.values.map((value, index) => (
                    <td key={tiers[index].id}><BenefitValue value={value} /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="preferred-footnotes" id="preferred-footnotes">
          <p>*根据入住酒店而有所变动</p>
          <p>**视酒店客房情况而定</p>
          <p>***适用于入住可以获得积分的房型的奖励</p>
        </div>
      </section>
    </main>
  );
}
